export default "__VITE_ASSET__BMZAPVSD__"